import {useEffect, useState} from "react";
import {v4} from "uuid";
import {use} from "i18next";

export default function YoutubeComponent({src, width, height, speed, _id}) {
    const id = _id || v4()

    return (
        <div id={id}>
            <iframe
                id={`${id}-player`}
                width={width || 420}
                height={height || 315}
                src={src}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen={true}
            />
        </div>
    )
}